(function () {
  function getStep(scroller) {
    var card = scroller.querySelector('.ksp__card');
    if (!card) return scroller.clientWidth;
    var styles = window.getComputedStyle(scroller);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function maxScroll(scroller) {
    return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  }

  function setDisabled(btn, disabled) {
    if (!btn) return;
    btn.disabled = disabled;
    btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  function update(root, scroller, prev, next) {
    var max = maxScroll(scroller);
    var left = scroller.scrollLeft;

    root.classList.toggle('ksp--single', max <= 1);
    setDisabled(prev, left <= 1);
    setDisabled(next, left >= max - 1);
  }

  function bindDrag(scroller, signal) {
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var tracking = false;
    var dragging = false;
    var suppressClick = false;
    var threshold = 10;

    scroller.addEventListener(
      'pointerdown',
      function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        tracking = true;
        dragging = false;
        suppressClick = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
      },
      { signal: signal }
    );

    document.addEventListener(
      'pointermove',
      function (e) {
        if (!tracking || e.pointerId !== pointerId) return;
        var delta = e.clientX - startX;

        if (!dragging) {
          if (Math.abs(delta) < threshold) return;
          dragging = true;
          suppressClick = true;
          scroller.classList.add('is-dragging');
        }

        scroller.scrollLeft = startScroll - delta;
      },
      { signal: signal }
    );

    function stopDrag(e) {
      if (!tracking || e.pointerId !== pointerId) return;
      tracking = false;
      dragging = false;
      pointerId = null;
      scroller.classList.remove('is-dragging');
    }

    document.addEventListener('pointerup', stopDrag, { signal: signal });
    document.addEventListener('pointercancel', stopDrag, { signal: signal });

    scroller.addEventListener(
      'click',
      function (e) {
        if (!suppressClick) return;
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
      },
      { capture: true, signal: signal }
    );
  }

  function init(root) {
    if (!root || root.dataset.kspReady === 'true') return;

    var scroller = root.querySelector('[data-ksp-scroller]');
    if (!scroller) return;

    root.dataset.kspReady = 'true';

    var prev = root.querySelector('[data-ksp-prev]');
    var next = root.querySelector('[data-ksp-next]');
    var abort = new AbortController();
    var signal = abort.signal;

    function refresh() {
      update(root, scroller, prev, next);
    }

    function scrollByDir(dir) {
      scroller.scrollBy({ left: getStep(scroller) * dir, behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          if (prev.disabled) return;
          scrollByDir(-1);
        },
        { signal: signal }
      );
    }

    if (next) {
      next.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          if (next.disabled) return;
          scrollByDir(1);
        },
        { signal: signal }
      );
    }

    bindDrag(scroller, signal);
    scroller.addEventListener('scroll', refresh, { passive: true, signal: signal });

    scroller.addEventListener(
      'keydown',
      function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollByDir(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollByDir(1);
        }
      },
      { signal: signal }
    );

    window.addEventListener('resize', refresh, { passive: true, signal: signal });

    root._kspAbort = abort;
    refresh();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ksp]').forEach(function (el) {
      if (el._kspAbort) {
        el._kspAbort.abort();
        el._kspAbort = null;
        delete el.dataset.kspReady;
      }
      init(el);
    });
  }

  window.initKspCarousel = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
